import UFOLoadHold from '@atlaskit/react-ufo/load-hold';
import { BoysenberryAppContext } from '@dev-agents/boysenberry-utils';
import { usePageTitle } from '@dev-agents/boysenberry-utils/src/ui/use-page-title';
import { useTenantData } from '@dev-agents/tenant-context';
import { useEffect } from 'react';
import { useQueryLoader } from 'react-relay';

import query, {
	type assignedToMeQuery,
} from './components/__generated__/assignedToMeQuery.graphql';
import { AssignedToMe } from './components/assigned-to-me';

export const BoysenberryHome = () => {
	usePageTitle('Flow');

	const { tenantContexts } = useTenantData();
	const { cloudId } = tenantContexts[0];

	const [queryRef, loadQuery] = useQueryLoader<assignedToMeQuery>(query);

	useEffect(() => {
		loadQuery({
			cloudId,
			jql: 'assignee = currentUser() AND statusCategory = "To Do" AND updated > "-4w" order by updated DESC',
		});
	}, [cloudId, loadQuery]);

	return (
		<BoysenberryAppContext>
			{queryRef ? <AssignedToMe queryRef={queryRef} /> : <UFOLoadHold name="boysenberry-home" />}
		</BoysenberryAppContext>
	);
};
